import React, { Component } from 'react';
import { StateContext, actions } from '../../state/index';
import { fetchPaymentStatus } from '../../api/index';
import { ERROR_TYPES, PAYMENT_STATUSES, TOKEN_TYPES } from '../../utils/enums';
import PollingForComplete from './PollingForComplete';
import { get } from 'lodash/object';
import { logUiError } from '../../utils/logging';
import { transformStatusErrorMessage } from '../../utils/errors';

const DEFAULT_POLLING_DURATION_IN_SECONDS = 20;
const DEFAULT_POLLING_INTERVAL_IN_SECONDS = 5;

export class Polling extends Component {
  constructor(props, context) {
    super(props);
    const [{ configuration }] = context;
    const pollingDurationInSeconds = get(
      configuration,
      'pollingForComplete.pollingDurationInSeconds',
      DEFAULT_POLLING_DURATION_IN_SECONDS
    );

    this.state = {
      timeRemaining: pollingDurationInSeconds,
      intervalId: null,
      status: 'polling',
    };
  }

  checkStatus = async () => {
    const [applicationState, dispatch] = this.context;
    const { payment, tokens } = applicationState;

    try {
      const response = await fetchPaymentStatus(
        payment.id,
        tokens[TOKEN_TYPES.RECIPIENT_LOGIN].access_token
      );
      const { status, message } = response.data;

      if (status === PAYMENT_STATUSES.COMPLETE) {
        clearInterval(this.state.intervalId);
        dispatch(actions.payment.updatePayment({ status }));
      } else if (
        [PAYMENT_STATUSES.PENDING_ACCEPTANCE, PAYMENT_STATUSES.FAILED].includes(
          status
        )
      ) {
        clearInterval(this.state.intervalId);

        const [{ configuration }] = this.context;
        const errorType = ERROR_TYPES.UI_ERRORS.FAILED_PAYMENT;
        const errorDescription =
          transformStatusErrorMessage(
            message,
            configuration.acceptPayment.errorMessages
          ) || get(configuration, `errors.uiErrors.${errorType}.description`);

        dispatch(
          actions.modals.showUiErrorModal(configuration, {
            errorType,
            contentProps: {
              showFaqLink: false,
              description: message || errorDescription, // default to server message; otherwise use error desriptions from configs
              actions: [
                {
                  label: 'Return to Paywall',
                  onClick: () => {
                    dispatch(actions.payment.updatePayment({ status }));
                    dispatch(actions.tokens.resetTokens());
                    dispatch(
                      actions.selectedPaymentNetwork.resetSelectedPaymentNetwork()
                    );
                  },
                },
              ],
            },
          })
        );

        logUiError(errorType, applicationState, {
          transformedErrorDescription: errorDescription,
          serverMessage: message,
          messageDisplayedToUser: message || errorDescription,
        });
      } else {
        this.setState({ status });
      }
    } catch (error) {
      console.log(error);
    }
  };

  componentDidMount() {
    const [{ configuration }] = this.context;
    const pollingIntervalInSeconds = get(
      configuration,
      'pollingForComplete.pollingIntervalInSeconds',
      DEFAULT_POLLING_INTERVAL_IN_SECONDS
    );

    const intervalId = setInterval(() => {
      if (this.state.timeRemaining <= 0) {
        // once polling window expires, update the global application payment state with the last received status
        clearInterval(this.state.intervalId);
        // eslint-disable-next-line no-empty-pattern
        const [{}, dispatch] = this.context;
        dispatch(actions.payment.updatePayment({ status: this.state.status }));
      } else {
        this.setState({
          timeRemaining: this.state.timeRemaining - pollingIntervalInSeconds,
        });
        this.checkStatus();
      }
    }, pollingIntervalInSeconds * 1000);

    this.setState({ intervalId });
  }

  componentWillUnmount() {
    if (this.state.intervalId) {
      clearInterval(this.state.intervalId);
    }
  }

  render() {
    return <PollingForComplete />;
  }
}

Polling.contextType = StateContext;

export default Polling;
